export const SCALES = [
  { value: 0, shortcut: 'q' },
  { value: 0.25, shortcut: 'w' },
  { value: 0.5, shortcut: 'e' },
  { value: 0.75, shortcut: 'r' },
  { value: 1, shortcut: 't' },
];

export function onCalculateScaleScore(weight: number, scale: number): { score: number } {
  const result = weight * scale;
  const notaResult = result.toFixed(2);
  return { score: parseFloat(notaResult) };
}
